import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, useMediaQuery} from '@mui/material';
import i18n from "i18next";
import {useTranslation} from "react-i18next";

const TemplateConfirmationDialog = ({ open, title, message, onConfirm, onCancel }) => {
    const isMobile = useMediaQuery("(max-width:767px)");
    const { i18n } = useTranslation();
    return (
        <Dialog
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                minHeight: "400px",
                margin: isMobile ? "10px" : "0px",
                zIndex: 99999,
            }}
            PaperProps={{
                style: {
                    position: "absolute",
                    borderRadius: "1vw",
                    minWidth: isMobile ? "0" : "clamp(27vh, 27vw, 27vw)",
                    minHeight: isMobile ? "0" : "auto",
                },
            }}
            open={open} onClose={onCancel}>
            <DialogTitle
            sx={{
                textAlign: "center",
            }}
            >{title}</DialogTitle>
            <DialogContent
                sx={{
                    textAlign: "center",
                }}>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    marginBottom: "1vw",
                    justifyContent: "space-evenly",
                    ...(isMobile && {
                        height: isMobile ? "0" : "50vh",
                        marginBottom: "1vw",
                        justifyContent: "flex-end",
                    }),
                }}
            >
                <Button
                    fullWidth
                    variant="outlined"
                    size="large"
                    onClick={onCancel} color="primary">
                    {i18n.t("common.NO")}
                </Button>
                <Button
                    fullWidth
                    size="large"
                    sx={{background : '#f54336'}}
                    onClick={onConfirm}
                    color="error" variant="contained">
                    {i18n.t("common.YES")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateConfirmationDialog;